import React, { FunctionComponent } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";
import { useDealerAddress } from "../../../stores/hooks/useDealerAddress";
import { OrderDetails } from "../../../stores/slices/cartSlice";
import {
  DEALER_DATE_TIME,
  DateDisplay,
} from "../../../ui/DateDisplay/DateDisplay";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";

export const CartPrintContactInfo: FunctionComponent<{
  orderDetails: OrderDetails;
}> = ({
  orderDetails: {
    customerEmail,
    customerName,
    customerNotes,
    customerPhone,
    orderCreatedTimestamp,
    orderCreatedUserName,
  },
}) => {
  const { t } = useTranslation();
  const { dealerContactEmail, dealerContactPhone, dealerName } =
    useDealerAccountInfo();
  const address = useDealerAddress();
  return (
    <section className="border border-edge rounded-section p-4">
      <h2 className="text-xl font-medium">{t("cart.contactInformation")}</h2>
      <div className="grid grid-cols-2">
        <div>
          <KeyValue>
            <>{t("cart.dealerName")}:</>
            <>{dealerName}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.dealerAddress")}:</>
            <>{address}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.dealerPhone")}:</>
            <>{dealerContactPhone ?? "N/A"}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.dealerEmail")}:</>
            <>{dealerContactEmail ?? "N/A"}</>
          </KeyValue>
        </div>
        <div>
          <KeyValue>
            <>{t("cart.customerName")}:</>
            <>{customerName ?? "N/A"}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.customerEmail")}:</>
            <>{customerEmail ?? "N/A"}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.customerPhone")}:</>
            <>{customerPhone ?? "N/A"}</>
          </KeyValue>
          <KeyValue>
            <>{t("cart.customerNotes")}:</>
            <>{customerNotes ?? "N/A"}</>
          </KeyValue>
        </div>
        <hr className="col-span-2 my-4" />
        <KeyValue>
          <>{t("cart.orderCreatedUserName")}:</>
          <>{orderCreatedUserName ?? "N/A"}</>
        </KeyValue>
        <KeyValue>
          <>{t("cart.orderCreatedTimestamp")}:</>
          <DateDisplay format={DEALER_DATE_TIME}>
            {orderCreatedTimestamp}
          </DateDisplay>
        </KeyValue>
      </div>
    </section>
  );
};
